import { render, staticRenderFns } from "./ChargebeeUpsellMarketingDomainsManager.vue?vue&type=template&id=dca5d634&scoped=true&"
import script from "./ChargebeeUpsellMarketingDomainsManager.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellMarketingDomainsManager.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellMarketingDomainsManager.vue?vue&type=style&index=0&id=dca5d634&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca5d634",
  null
  
)

export default component.exports